module.exports = "/_next/static/images/ArtificialIntelligence-5bb62df48dfb1408a15f41ffefa62f9c.webp";